"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _immer = _interopRequireDefault(require("immer"));

var _icons = require("@ant-design/icons");

var _GatsbyImage = _interopRequireDefault(require("../GatsbyImage"));

var _MediaLibrary = _interopRequireDefault(require("../MediaLibrary"));

var _theme = require("../../theme");

var _redux = require("../../redux");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10;

var Gallery = function Gallery(props) {
  var onChange = props.onChange,
      value = props.value;
  var dispatch = (0, _redux.useAppDispatch)();
  var values = value || [];

  var handleRemove = function handleRemove(index) {
    var newValues = (0, _immer.default)(values, function (draft) {
      draft.splice(index, 1);
      return draft;
    });
    onChange(newValues);
  };

  var handleMoveElement = function handleMoveElement(index, newIndex) {
    var newValues = (0, _immer.default)(values, function (draft) {
      if (newIndex > -1 && newIndex < draft.length) {
        var temp = draft[index];
        draft[index] = draft[newIndex];
        draft[newIndex] = temp;
      }

      return draft;
    });
    onChange(newValues);
  };

  var handleSelect = function handleSelect(items) {
    onChange(items);
  };

  var handleClickAdd = function handleClickAdd() {
    dispatch(_redux.uiActions.showDialog({
      open: true,
      title: 'Media',
      component: /*#__PURE__*/_react.default.createElement(_MediaLibrary.default, {
        onSelect: handleSelect,
        allow: ['image'],
        selected: values,
        multiple: true
      }),
      width: 1024
    }));
  };

  return /*#__PURE__*/_react.default.createElement(Container, null, values && values.map(function (o, i) {
    return /*#__PURE__*/_react.default.createElement(GalleryItem, {
      key: i
    }, /*#__PURE__*/_react.default.createElement(ImageContainer, null, o && /*#__PURE__*/_react.default.createElement(_GatsbyImage.default, {
      image: o,
      objectFit: "cover",
      objectPosition: "50% 50%",
      alt: o.alt,
      style: {
        width: '100%',
        height: '100%'
      }
    })), /*#__PURE__*/_react.default.createElement(LeftIcon, {
      disabled: i - 1 === -1,
      className: "icon",
      onClick: function onClick() {
        return i - 1 > -1 && handleMoveElement(i, i - 1);
      }
    }, /*#__PURE__*/_react.default.createElement(_icons.LeftCircleOutlined, {
      style: {
        color: _theme.colors.secondary
      }
    })), /*#__PURE__*/_react.default.createElement(RightIcon, {
      disabled: i === values.length - 1,
      className: "icon",
      onClick: function onClick() {
        return i < values.length && handleMoveElement(i, i + 1);
      }
    }, /*#__PURE__*/_react.default.createElement(_icons.RightCircleOutlined, {
      style: {
        color: _theme.colors.secondary
      }
    })), /*#__PURE__*/_react.default.createElement(RemoveIcon, {
      className: "icon",
      onClick: function onClick() {
        return handleRemove(i);
      }
    }, /*#__PURE__*/_react.default.createElement(_icons.CloseCircleOutlined, {
      style: {
        color: _theme.colors.danger
      }
    })));
  }), /*#__PURE__*/_react.default.createElement(AddContainer, null, /*#__PURE__*/_react.default.createElement(AddButton, {
    onClick: handleClickAdd
  }, /*#__PURE__*/_react.default.createElement(_icons.PlusOutlined, null))));
};

var Container = _styledComponents.default.div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  display: flex;\n  flex-wrap: wrap;\n"])));

var GalleryItem = _styledComponents.default.div(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n  position: relative;\n  height: 75px;\n  width: 75px;\n  margin-right: 10px;\n  margin-bottom: 10px;\n\n  &:hover {\n    &:before {\n      content: '';\n      position: absolute;\n      left: 0;\n      top: 0;\n      z-index: 1;\n      width: 100%;\n      height: 100%;\n      background: rgba(240, 242, 245, 0.8);\n    }\n\n    .icon {\n      opacity: 1;\n      pointer-events: all;\n    }\n  }\n"])));

var icon = (0, _styledComponents.css)(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2.default)(["\n  position: absolute;\n  z-index: 2;\n  cursor: pointer;\n  opacity: 0;\n  pointer-events: none;\n  transition: ease all 0.2s;\n  background: #fff;\n  border-radius: 50%;\n  height: 14px;\n  width: 14px;\n\n  ", "\n\n  .anticon {\n    display: block;\n  }\n"])), function (_ref) {
  var disabled = _ref.disabled;
  return disabled && (0, _styledComponents.css)(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2.default)(["\n      svg {\n        opacity: 0.2;\n      }\n    "])));
});

var RemoveIcon = _styledComponents.default.div(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2.default)(["\n  ", "\n  right: 4px;\n  top: 4px;\n"])), icon);

var LeftIcon = (0, _styledComponents.default)('div')(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2.default)(["\n  ", "\n  left: calc(50% - 20px);\n  bottom: 4px;\n"])), icon);
var RightIcon = (0, _styledComponents.default)('div')(_templateObject7 || (_templateObject7 = (0, _taggedTemplateLiteral2.default)(["\n  ", "\n  right: calc(50% - 25px);\n  bottom: 4px;\n"])), icon);

var ImageContainer = _styledComponents.default.div(_templateObject8 || (_templateObject8 = (0, _taggedTemplateLiteral2.default)(["\n  height: 100%;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: ", ";\n"])), _theme.colors.secondaryContrast);

var AddContainer = _styledComponents.default.div(_templateObject9 || (_templateObject9 = (0, _taggedTemplateLiteral2.default)(["\n  margin-bottom: 10px;\n"])));

var AddButton = _styledComponents.default.div(_templateObject10 || (_templateObject10 = (0, _taggedTemplateLiteral2.default)(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 75px;\n  width: 75px;\n  border: 1px solid ", ";\n  cursor: pointer;\n  transition: ease all 0.2s;\n"])), _theme.colors.tertiary);

var _default = Gallery;
exports.default = _default;